export default "__VITE_ASSET__BldiVoAd__"